import React from 'react';

import InquirySection from 'components/Patients/InquirySection';

export interface IInquiryContainer {
  content: {
    headline: string;
    description?: {
      description: string;
    };
    backgroundColor?: string;
    slug?: string;
  };
}

export const InquiryContainer: React.FC<IInquiryContainer> = (props) => {
  const { content } = props;

  if (!content) return null;

  const { headline, description, backgroundColor, slug } = content;

  return (
    <>
      <InquirySection
        backgroundColor={backgroundColor}
        headline={headline}
        description={description?.description || ''}
        slug={slug}
      />
    </>
  );
};

export default InquiryContainer;
